'use strict';

var React = require('react');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./homepage.scss');
}

var Global = require('../../global');
var ResponsiveMixin = Global.ResponsiveMixin;

var CollectionsSegment = require('./homepage/homepage-collections.jsx');
var BlogSegment        = require('./homepage/homepage-blog.jsx');
var VideoSegment       = require('./homepage/homepage-videos.jsx');

var Home = React.createClass({
    mixins: [ ResponsiveMixin ],

    render: function() {
        return (
            <div className='homepage'>
            
                <CollectionsSegment />

                <div className='hp-fullservice'>
                    <h2>We feature the best in class Contemporary Office Furniture for today’s Modern Workplace with the most design options available anywhere.</h2>
                </div>

                {this.state.viewportLayout == 'desktop' ?
                    <BlogSegment />
                : null}

                <VideoSegment />

            </div>
        );
    }
});

module.exports = Home;



// WEBPACK FOOTER //
// ./src/pages/content/homepage.jsx